module.exports = __webpack_public_path__ + "img/DomainDist.cdfd3e94.png";